import {Directive,Input,ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[loader-host]',
})
// TODO : le nom est-il suffisament clair pour tout le monde ???
export class LoaderDirective {
    @Input() loaderName:string;

    constructor(public viewContainerRef: ViewContainerRef) {

    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/directives/loader-directive.ts